import { icons } from 'common'

import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .asset_menu {
    width: 100%;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .asset_menu .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  }
  .asset_menu .select-box {
    position: relative;
    display: block;
    font-weight: 300;
    width: 100%;
    border-radius: 5px;
    white-space: nowrap;
  }
  .asset_menu .select-box__current {
    position: relative;
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
  }
  .asset_menu .select-box__input + .select-box__input-text:hover {
    background: hsl(218, 23%, 25%);
  }
  .asset_menu .select-box__input:checked + .select-box__input-text:hover {
    background: transparent;
  }
  .asset_menu .select-box__current:focus .menu_select {
    transform: translateY(-50%) rotate(0);
  }
  .asset_menu .menu_select {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%) rotate(180deg);
    width: 20px;
    opacity: 1;
    transition: 0.5s ease;
  }
  .asset_menu .select-box__value {
    display: flex;
  }
  .asset_menu .select-box__input {
    display: none;
  }
  .asset_menu .select-box__input:checked + .select-box__input-text {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    width: calc(100% - 25px);
    justify-content: space-between;
  }
  .asset_menu .select-box__input-text {
    display: none;
    border-radius: 10px;
  }
  .asset_menu .select-box__input-text img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 0;
  }
  .asset_menu .select-box__input-text .single_asset_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 0 30px 0 0;
  }
  .asset_menu .select-box__input-text .tfh_change {
    font-size: 0.75rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin: 2px 25px 0 0;
  }
  .asset_menu .select-box__input-text .tfh_change.no_menu_select {
    margin: 2px 0 0 0;
  }
  .asset_menu .select-box__input-text .tfh_change.down {
    color: var(--site-result-lost-color);
  }
  .asset_menu .select-box__input-text .tfh_change.up {
    color: var(--site-result-won-color);
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/gameplay.css */

  &.asset_display {
    background: hsla(0, 0%, 100%, 0.1);
    height: fit-content;
    border-radius: 10px;
    line-height: 100%;
    padding: 10px 15px;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin: 0 10px 0 0;
  }
  @media (max-width: 600px) {
    &.asset_display {
      padding: 10px;
      margin-right: 5px;
    }
    .asset_menu .select-box__input:checked + .select-box__input-text {
      font-size: 0.9rem;
      width: calc(100% - 25px);
    }
    .asset_menu .select-box__input-text .single_asset_wrapper {
      margin: 0 10px 0 0;
    }
    .asset_menu .select-box__input-text img {
      width: 18px;
      height: 18px;
      margin: 0 4px 0 0;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 800px) {
    .current_price_display label {
      font-size: 1.4rem;
      letter-spacing: -0.03em;
    }
    .current_price_display .price_direction_icon {
      -webkit-mask: url(${icons.bid_direction_icon}) center center / auto 14px no-repeat;
      mask: url(${icons.bid_direction_icon}) center center / auto 14px no-repeat;
      width: 14px;
      height: 14px;
      margin: 0 5px 0 0;
    }
  }
`

const devCSS = css``

export const SelectBoxCurrent = styled.div`
  ${designerCSS}
  ${devCSS}
`

const assetDisabled = css`
  opacity: 0.5;
  cursor: not-allowed !important;
`

export const SelectDropdown = styled.ul`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  top: 50px;
  left: 0;
  width: 100%;

  width: content;
  padding: 0px;
  list-style: none;
  overflow: hidden;
  overflow-y: auto;
  z-index: ${({ zIndex }) => zIndex || 1};
  box-shadow: 0px 5px 8px 0px rgb(0 0 0 / 50%);
  backdrop-filter: blur(20px);
  font-size: 0.8rem;
  border-radius: 10px;
  margin: 0;
  /* margin-top: -50px; */
  background: var(--asset-dropdown-background);
  backdrop-filter: blur(20px);
  opacity: 0;
  max-height: ${({ isShow }) => (isShow ? '300px' : '0')};
  transition: opacity 0.3s linear;
  ${({ isShow }) => (isShow ? 'opacity : 1' : '')};
`
export const SelectDropdownTitle = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* padding: 10px 15px; */
  backdrop-filter: blur(0) !important;
  white-space: break-spaces;
  font-weight: 800 !important;
  font-size: 0.7rem;
  pointer-events: none;
  padding: 20px 15px 10px 15px !important;
`
export const HotPeriod = styled.span`
  position: absolute;
  font-weight: inherit;
  right: 5px;
`

export const SelectDropdownItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 15px !important;
  white-space: break-spaces;
  font-size: 0.8rem;
  ${({ disabled }) => (disabled ? assetDisabled : '')}

  &:hover {
    background: hsl(218, 23%, 25%);
  }
  &.info {
    font-size: 0.7rem;
  }
  &.change {
  }
`
export const IconSelected = styled.div`
  width: 18px;
  height: 18px;
  margin: 0 5px 0 0;
  background-image: url(${({ icon }) => icon});
  background-repeat: no-repeat;
  background-size: contain;
`
export const NameSelected = styled.span`
  font-size: 1rem;
  font-weight: 400;
  margin: 0 15px 0 0;
  /* min-width: 60px; */
`

export const Icon = styled.div`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 0 !important;
  background-image: url(${({ icon }) => icon});
  background-repeat: no-repeat;
  background-size: contain;
`
export const Name = styled.span`
  font-weight: 300;
  margin: 0 15px 0 0 !important;
`
export const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

export const SelectedAsset = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`
export const AssetChange = styled.div`
  position: absolute;
  right: 5px;
  font-size: 0.9rem;
  &.up {
    color: var(--site-result-won-color);
  }
  &.down {
    color: var(--site-result-lost-color);
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const MenuSelect = styled.div`
  width: 18px;
  height: 18px;
  background: rgba(0, 0, 0, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
  filter: invert(1);
  border-radius: 3px;
  /* cursor: pointer; */
  transition: all 150ms ease-in;
  transform: rotate(${({ isShow }) => (isShow ? '0deg' : '-180deg')});
`
export const FilterBox = styled.input`
  border: 0;
  outline: 0;
  position: absolute;
  top: -5px;
  left: 0;
  background: var(--input-background) url(${icons.search_icon}) 93% center / auto 12px no-repeat;
  backdrop-filter: blur(20px);
  transition: 0.5s ease-in-out;
  padding: 0 15px 0 15px !important;
  height: 30px;
  line-height: 100%;
  border-radius: 5px;
  font-size: 0.8rem;
  width: 100%;
`
